// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-3Ebjv";
var _3 = "paper-fZKLC";
var _4 = "classes__title-3lyiq";
var _5 = "content-26Fft";
var _6 = "footer-KXN1m";
var _7 = "footer__price-3QSfv";
var _8 = "confirmButton-9bDMh";
var _9 = "cancelButton-3Gl2D";
var _a = "closeButton-xbAzB";
export { _1 as "__esModule", _2 as "title", _3 as "paper", _4 as "classes__title", _5 as "content", _6 as "footer", _7 as "footer__price", _8 as "confirmButton", _9 as "cancelButton", _a as "closeButton" }
export default { "__esModule": _1, "title": _2, "paper": _3, "classes__title": _4, "content": _5, "footer": _6, "footer__price": _7, "confirmButton": _8, "cancelButton": _9, "closeButton": _a }
